///在此处编写调用授权等基本平台接口
class oh_api {
	constructor(axiosFactory) {
		this.$http = axiosFactory;
	}
	http() {
		return this.$http;
	};
	get(url, cb) {
		this.$http.get(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});;
	}
	gets(url, data, cb) {
		this.$http.get(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	post(url, data, cb) {
		this.$http.post(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	posts(url, cb) {
		this.$http.post(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	put(url, data, cb) {
		this.$http.put(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	puts(url, cb) {
		this.$http.put(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	delete(url, data, cb) {
		this.$http.delete(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	deletes(url, cb) {
		this.$http.delete(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	//------------------------------------------------------------
	getGoldHunters(chainName, pageNum, cb) {
		this.get(`/hunter/chain/${chainName}/goldHunters?pageNum=${pageNum}20&pageSize=10`, cb)
	}
	//[猎头管理]获取猎头信息
	searchGoldHunters(mobile, name, pageNum, cb) {
		if (mobile && name) {
			this.get(`/hunter/chain/hunters?mobile=${mobile}&name=${name}&pageNum=${pageNum}&pageSize=10`, cb)
		} else if (!name && !mobile) {
			this.get(`/hunter/chain/hunters?pageNum=${pageNum}&pageSize=10`, cb)
		} else if (name) {
			this.get(`/hunter/chain/hunters?name=${name}&pageNum=${pageNum}&pageSize=10`, cb)
		} else if (mobile) {
			this.get(`/hunter/chain/hunters?mobile=${mobile}&pageNum=${pageNum}&pageSize=10`, cb)
		}
	}
	//[猎头管理]设置为金牌猎头--设置为金牌猎头
	changeGoldHunters(data, cb) {
		this.post(`/hunter/goldHunters`, data, cb)
	}
	//获取金牌猎头初始数据
	getbasicGoldHunters(userName,cb) {
		this.get(`/hunter/${userName}/goldHunters?pageNum=1&pageSize=3`, cb)
	}
	//删除金牌猎头
	deleteGoldHunter(hunterId, cb) {
		this.deletes(`/hunter/goldHunter/${hunterId}`, cb)
	}
	// 	introductionGoldHunter(hunterId,data,cb){
	// 		this.put(`/hunter/goldHunter/${hunterId}/introduction`,data,cb)
	// 	}
	//[猎头管理]设置为金牌猎头--未设置为金牌猎头
	getHuntersData(userName, cb) {
		this.get(`/hunter/${userName}/goldHunter`, cb)
	}
	//获取代办事项详情
	getHometodos(cb) {
		this.get(`/company/home/todos`, cb)
	}
	//[购买金币]
	getMyWallet(cb) {
		this.get("/company/wallet", cb);
	}
	//金币分配
	postAllocatingcoins(data, cb) {
		this.post(`/allocating/coins`, data, cb)
	}
	//相似猎头
	getSimilardHunter(hunterName, cb) {
		this.get(`/hunter/${hunterName}/home/recommendHunter?pageNum=1&pageSize=15`, cb)
	}

}
class apiFactory {
	constructor() {

	}
	createApi(axios) {
		return new oh_api(axios)
	}
}
export default new apiFactory();
